import {AuthContext} from "../context/AuthContext";
import {useContext} from "react";
import {Navigate, Outlet} from "react-router-dom";

export default function RequireAuth() {
    const {isAuthenticated, ready} = useContext(AuthContext)

    if (!ready) {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace></Navigate>
    }

    return <Outlet />
}